import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/notification/unreadCount/notification.unreadCount.query.gql"
import type {
  StaffNotificationUnreadCountQuery,
  StaffNotificationUnreadCountQueryVariables,
} from "@/v2-backoffice-client/notification/unreadCount/__types__/notification.unreadCount.query"

type Options = QueryHookOptions<
  StaffNotificationUnreadCountQuery,
  StaffNotificationUnreadCountQueryVariables
>

export function useStaffNotificationUnreadCountQuery(options?: Options) {
  return useQuery<
    StaffNotificationUnreadCountQuery,
    StaffNotificationUnreadCountQueryVariables
  >(query, options)
}
